module.exports = __webpack_public_path__ + "img/Bridgeicon.c7384b44.svg";